var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0294,
    y: 0.606125,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(15 15.0294 0.606125)",
    fill: "#36BFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_43156_24789)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 47V45C34 43.1362 32.7252 41.5701 31 41.126M27.5 29.2908C28.9659 29.8841 30 31.3213 30 33C30 34.6787 28.9659 36.1159 27.5 36.7092M29 47C29 45.1362 29 44.2044 28.6955 43.4693C28.2895 42.4892 27.5108 41.7105 26.5307 41.3045C25.7956 41 24.8638 41 23 41H20C18.1362 41 17.2044 41 16.4693 41.3045C15.4892 41.7105 14.7105 42.4892 14.3045 43.4693C14 44.2044 14 45.1362 14 47M25.5 33C25.5 35.2091 23.7091 37 21.5 37C19.2909 37 17.5 35.2091 17.5 33C17.5 30.7909 19.2909 29 21.5 29C23.7091 29 25.5 30.7909 25.5 33Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_43156_24789",
    x: -16,
    y: -2,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_43156_24789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_43156_24789",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.250a4368df8cc85cab57c2e284d77ea1.svg";
export { ForwardRef as ReactComponent };